var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.832 0 0 5.832 0 13c0 7.169 5.832 13 13 13s13-5.831 13-13c0-7.168-5.832-13-13-13zm0 25C6.383 25 1 19.616 1 13 1 6.383 6.383 1 13 1c6.616 0 12 5.383 12 12 0 6.616-5.384 12-12 12z",
    transform: "translate(-1000.000000, -836.000000) translate(1000.000000, 834.000000) translate(0.000000, 2.000000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.481 12.222H13.52V6.52c0-.287-.233-.519-.519-.519-.286 0-.519.232-.519.519v5.703H6.52c-.287 0-.519.232-.519.519 0 .286.232.518.519.518h5.962v6.222c0 .287.233.519.519.519.286 0 .519-.232.519-.519V13.26h5.962c.287 0 .519-.232.519-.518 0-.287-.232-.519-.519-.519z",
    transform: "translate(-1000.000000, -836.000000) translate(1000.000000, 834.000000) translate(0.000000, 2.000000)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreCircle);
export default __webpack_public_path__ + "static/media/moreCircle.4fb3cdfc.svg";
export { ForwardRef as ReactComponent };